<template>
<v-form v-model="valid" :disabled="terminer">
    <v-container v-if="store.state.user.token&&groupe.find(g=>g==store.state.user.groupe)">
        <v-progress-linear  v-if="store.state.waiting"  color="antiquewhite" indeterminate></v-progress-linear>
        <v-sheet :elevation="10"  width="600" :disabled="terminer" style="margin-top: 0.5em;">
            <v-toolbar color="#008080" height="30"><v-toolbar-title>Ticket?</v-toolbar-title></v-toolbar>
            <v-card-text>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-checkbox label="Avec ticket" v-model="ticket" @change="sTicket=false"></v-checkbox>
                        <v-checkbox label="Sans ticket" style="margin-top: -40px;" v-model="sTicket" @change="ticket=false"></v-checkbox>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-sheet>
        <div v-if="sTicket||ticket">
        <v-sheet :elevation="10"  width="600" style="margin-top: 0.5em;" >
            <v-toolbar color="#008080" height="30"><v-toolbar-title>Articles</v-toolbar-title></v-toolbar>
            <DialogReceptionFripe :terminer :ticket></DialogReceptionFripe>
            <v-table>
                <thead >
                    <tr >
                        <th>Action</th>
                        <th v-for="item in headers"
                            :key="item.name">{{ item.title }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="item in store.state.articlesFripe.sort((a, b) => a.marque - b.marque)"
                                :key="item"
                    >
                        <td>
                            <v-btn-group
                            color="#b2d7ef"
                            density="comfortable">
                            <v-icon style="margin-top: 1em;" icon="$error"  color="error" @click="deleteDialog=true;supprimer(item)" :disabled="terminer"></v-icon>
                            </v-btn-group>
                        </td>
                        <td>{{ item.marque }}</td> 
                        <td>{{ item.grade }}</td>
                        <td>{{ item.composition }}</td>
                        <td>{{ item.sousFamille }}</td>
                        <td>{{ item.libCouleur }}</td>
                        <td>€{{ item.prixAchatHT }}</td>
                        <td>€{{ item.prixAchatOrigine }}</td>
                        <td><input type="text" :disabled="terminer" :value="item.qteCommande" style="text-align: center;" size="2" @change="modifier($event.target.value,item.id,'qteCommande')"> </td>
                        <td><ul ><li v-for="el in item.accessoires">{{ el }}</li></ul></td>
                        <td style="text-align: center;" size="2">€ {{ item.totalBrut }}</td>
                    </tr>
                    <tr>
                        <td><h6>Total</h6> </td>
                        <td v-for="i in 9"
                            :key="i">
                        </td>
                        <td><h6>€ {{sum(store.state.articlesFripe,"totalBrut")}}</h6></td>
                    </tr>
                    <tr>

                    </tr>
                </tbody>
            </v-table>
            <Supprimer v-model="deleteDialog" :itemtoDelete></Supprimer>
            
        </v-sheet>
        <v-sheet :elevation="10" :disabled="terminer">
            <v-card >
                <div class="text-center pa-4">
                    <v-file-input
                        accept="image/png, image/jpeg, image/bmp"
                        label="Photos"
                        variant="outlined"
                        multiple
                        placeholder="importer les photos"
                        prepend-icon="mdi-camera"
                        @change="selectFile($event.target.files)"
                    ></v-file-input>
                </div>
                <v-card v-if="store.state.photoLinks.exist" >
                    <table style="margin-bottom: 5px;" >
                        <tbody>
                            <tr> 
                                <td v-for="(el, index) in store.state.photoLinks.id">
                                    <v-icon style="margin-left: 5px;"  icon="$error"  color="error" @click="supprimerPhoto(el)"></v-icon>
                                    <button @click="imageDialog=true;getPhotos(el)" type="button" class="btn btn-outline-secondary btn-sm">Photo {{ index+1 }}</button>
                                </td>
                            </tr>
                        </tbody>
                    </table> 
                </v-card>
            </v-card>
        </v-sheet>
        <v-sheet :elevation="10"  width="600" :disabled="terminer" style="margin-top: 0.5em;">
            <v-toolbar color="#008080" height="30"><v-toolbar-title>Bon du {{ date }}</v-toolbar-title></v-toolbar>
            <v-card-text>
                <v-row>

                    <v-col cols="12" md="6">
                        <v-text-field v-model="informations" label="Réf de Suivi" ></v-text-field>
                    </v-col>
                    <!-- <v-col cols="12" md="6"> -->
                        <div class="text-center pa-4">
                            <v-btn @click="getReceptions()"  color="#008080">
                                Réceptions 
                            </v-btn>
                            <v-dialog
                                v-model="dialogReceptions"
                                width="auto"
                            >
                                <v-card
                                max-width="300"
                                prepend-icon="mdi-update"
                                title="Réceptions en cours"
                                >
                                <v-list :items="receptions"></v-list>
                                <template v-slot:actions>
                                    <v-btn
                                    class="ms-auto"
                                    text="Ok"
                                    color="#008080"
                                    @click="dialogReceptions = false"
                                    ></v-btn>
                                </template>
                                </v-card>
                            </v-dialog>
                        </div>
                    <!-- </v-col> -->
                </v-row>
            </v-card-text>
        </v-sheet>
        <v-sheet :elevation="10"  width="600" style="margin-top: 0.5em;" :disabled="terminer">
            <v-toolbar color="#008080" height="30"><v-toolbar-title>Magasin</v-toolbar-title></v-toolbar>
            <v-card-text>
                <v-row>
                    <v-col cols="12" md="3">
                    <v-combobox clearable label="Magasin" :items="itemMagasin" v-model="magasin" ></v-combobox>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-text-field v-model="vendeur" label="Vendeuse/Vendeur" :disabled="terminer"></v-text-field>
                    </v-col>
                    
                </v-row>
            </v-card-text>

        </v-sheet>
        <v-sheet :elevation="10"  width="600" style="margin-top: 0.5em;">
            <v-toolbar color="#008080" height="30"><v-toolbar-title>Client</v-toolbar-title></v-toolbar>
            <v-tabs v-model="tab" bg-color="grey" height="30">
            <v-tab value="one" :disabled="terminer">Recherche Client</v-tab>
            <v-tab value="two" :disabled="terminer"> {{ creationClient }}</v-tab>
            </v-tabs>               
            <v-card-text>
                <v-tabs-window v-model="tab">
                    <v-tabs-window-item value="one">
                        <form action="" @submit.prevent="getClients()">
                            <v-card >
                                <v-row>
                                    <v-col cols="12" md="3">
                                        <v-text-field v-model="lastname" label="Nom"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-text-field v-model="firstname" label="Prénom"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-text-field v-model="telephone" label="Téléphone"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-text-field v-model="ville" label="Ville"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-btn v-if="telephone||lastname||firstname" 
                                    style="margin-bottom: 2em;" :disabled="terminer"
                                    :loading="loading" block color="#008080"
                                    @click="loading = true;affichageClient=true"
                                        type="submit">
                                    Rechercher
                                        <v-progress-linear indeterminate ></v-progress-linear>
                                </v-btn>
                                <v-row >
                                    <v-card style="margin-top: 2em;" v-if="affichageClient">
                                        <v-list-item link v-for="item in store.state.clients" :width="900" @click="choixClient(item);affichageClient=false;creationClient='Modifier client'">
                                            {{ `${item.t_libelle} - ${item.t_prenom} - ${item.t_telephone} - ${item.t_ville} - ${item.t_pays} - ${item.t_tiers}` }}
                                        </v-list-item>
                                    </v-card>
                                </v-row>
                            </v-card> 
                        </form>
                    </v-tabs-window-item>

                    <v-tabs-window-item value="two" id="element-to-convert2">
                        <v-card>
                            <v-row>
                                <v-checkbox label="Mme." v-model="mme" @change="mr=false" style="margin-left: 1em;"></v-checkbox><v-checkbox label="M." v-model="mr" @change="mme=false"></v-checkbox> 
                            </v-row>
                            <v-row>
                                <v-col  cols="12" md="3">
                                    <v-text-field  v-model="firstname" label="Prénom"></v-text-field>
                                </v-col>

                                <v-col cols="12" md="3" >
                                    <v-text-field v-model="lastname" label="Nom"></v-text-field>
                                </v-col>

                                <v-col cols="12" md="3">
                                <v-text-field
                                        v-model="birdhDay"
                                        label="Date de naissance"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3">
                                </v-col>
                                <v-row>
                                    <v-col cols="12"  md="3">
                                        <v-text-field v-model="telephone" label="Téléphone"></v-text-field>
                                    </v-col> 
                                    <v-col cols="12" md="4">
                                        <v-text-field v-model="email" label="E-mail" ></v-text-field>
                                    </v-col> 
                                </v-row>
                            </v-row>
                            <v-row>
                                <v-col cols="12"  md="3">
                                    <v-combobox clearable v-model="pays" label="Pays" :items="itemsPays"></v-combobox>
                                    <!-- <v-text-field v-model="pays" label="Pays"></v-text-field> -->
                                </v-col> 
                                <v-col cols="12"  md="3">
                                    <v-text-field v-model="codePostal" label="Code Postal"></v-text-field>
                                </v-col> 
                                <v-col cols="12" md="3">
                                    <v-text-field v-model="ville" label="Ville" ></v-text-field>
                                </v-col> 
                            </v-row>
                            <v-row>
                                <v-col cols="12"  md="5">
                                    <v-text-field v-model="adresse" label="Adresse"></v-text-field>
                                </v-col> 

                            </v-row>
                            <v-btn block color="#008080"  :disabled="terminer||libelleAjout=='Modifié'||libelleAjout=='Ajouté'"
                                        
                                        @click="(libelleAjout=='Modifier'?validerClient():addClient());(libelleAjout=libelleAjout=='Modifier'?'Modifié':'Ajouté')">
                                        {{libelleAjout}}
                                            <!-- <v-progress-linear loading = true; indeterminate ></v-progress-linear ||libelleAjout=='Modifié'||libelleAjout=='Ajouté'> -->
                            </v-btn>
                            
                        </v-card> 
                       
                    </v-tabs-window-item>
                </v-tabs-window>
            </v-card-text>
        </v-sheet>
        <v-sheet :elevation="10"  width="600" style="margin-top: 0.5em;">
            <v-btn @click="signature=!signature"  block  color="#008080"  style="margin-top: 0.5em;" v-if="!store.state.signature.exist">Signature</v-btn>
            <v-card v-if="signature"  style="margin-top: 0.5em;" >
                <p style="margin: 0.5em;">Je soussigné(e) {{firstname}} {{lastname}} certifie transférer mon article dans l'état déclaré et accepte les Conditions Générales d'Utilisation liées au service de seconde main d'Edisac disponibles sur le site edisac.com.</p>
                <p style="margin: 0.5em;">J'atteste également céder la propriété de mon article à Edisac pour expertise et mise en vente, sous réserve d'une expertise favorable.</p>
                <h6 style="margin: 0.5em;color:red">Signature:</h6>
                <v-row>
                    <v-checkbox label="Retour de l'article en magasin pour le récupérer" v-model="choixReprise1" @change="choixReprise2=false;choixReprise='reprendre'" style="margin-left: 1em;"></v-checkbox>
                </v-row>
                <v-row style="margin-top: -40px ;">
                    <v-checkbox label="Don à une association" v-model="choixReprise2" @change="choixReprise1=false;choixReprise='association'" style="margin-left: 1em;"></v-checkbox> 
                </v-row>
                <div class="text-center pa-4" v-if="signature&&!store.state.signature.exist">
                    <v-card elevation="16" >
                        <Signature  ></Signature>
                    </v-card>
                    
                </div>
                
                <div class="text-center pa-4" v-if="store.state.signature.exist">
                    <v-card elevation="16" >
                        <img class="fit-picture" :src="store.state.signature.link"></img>
                    </v-card>
                </div>
                
            </v-card>

        </v-sheet>
        <v-sheet :elevation="10"  width="600" style="margin-top: 0.5em;">
            <div class="text-center pa-4">
                <v-text-field   v-model="email" label="E-mail"></v-text-field> 
            </div>
            <div class="text-center pa-4">
                
                <v-btn style="margin-top: -20px;" @click="validerArticles();dialogFinale=true;terminer=true"  block  color="success" :disabled="terminer||store.state.articlesFripe.length==0||!email||!store.state.signature.exist" >
                Valider 
                </v-btn>
                
            
                <v-dialog
                    v-model="dialogFinale"
                    width="auto"
                >
                    <v-card
                    max-width="400"
                    prepend-icon="mdi-update"
                    :text="`La reception numéro: ${store.state.numeroBon} a été créé correctement. Elle est encours de traitement auprès de notre service d'expertise`"
                    title="Vérification en cours"
                    >
                    <template v-slot:actions>
                        <v-btn
                        class="ms-auto"
                        text="Ok"
                        @click="dialogFinale = false"
                        ></v-btn>
                    </template>
                    </v-card>
                </v-dialog>
            </div>
            <!-- <v-btn @click="NouvelleReception()" block  color="warning" style="margin-bottom: 5em;">
                Nouvelle Reception
            </v-btn> -->
            <div class="text-center pa-4">
                <v-btn @click="dialogNewReception=true" block  color="warning" style="margin-bottom: 5em;">
                    Nouvelle Reception
                </v-btn>
                
            
                <v-dialog
                    v-model="dialogNewReception"
                    width="auto"
                >
                    <v-card
                    max-width="400"
                    prepend-icon="mdi-update"
                    :text="`C'est pour le même client?`"
                    title="Nouvelle réception"
                    >
                    <template v-slot:actions>
                        <v-btn
                        class="ms-auto"
                        text="Oui"
                        color="green"
                        @click="NouvelleReception(true);dialogNewReception = false"
                        ></v-btn>
                        <v-btn
                        class="ms-auto"
                        text="Non"
                        color="red"
                        @click="NouvelleReception(false);dialogNewReception = false"
                        ></v-btn>
                    </template>
                    </v-card>
                </v-dialog>
            </div>
                <!-- <v-btn @click="sendEmail()">
                    sendEmail
                </v-btn> -->
        </v-sheet>
        </div>
        
        
        <!-- <Pdf id="element-to-convert" :vendeur :magasin v-if="recap"></Pdf> -->
    </v-container>
  </v-form>
    <div class="text-center pa-4">
      <v-dialog v-model="imageDialog" width="600">
        <v-card width="600">
            <v-img
                width="600"
                cover
                :src="srcImage"
            ></v-img>
        </v-card>
      </v-dialog>
    </div>
</template>
<script setup>
import { onMounted, ref} from 'vue'
import store from './store'
import DialogReceptionFripe from './DialogReceptionFripe.vue'
import Supprimer from './Supprimer.vue'
import axios from 'axios'
import Signature from './Signature.vue'
let sTicket=ref(false)
let ticket=ref(false)
let dialogFinale=ref(false)
let dialogReceptions=ref(false)
let dialogNewReception=ref(false)
let receptions=ref()
let srcImage=ref()
let imageDialog=ref(false)
const date = new Date(Date.now()).toLocaleString().split(' ')[0];
let terminer=ref(false)
let photo=ref(false)
let signature=ref(false)
let affichageClient=ref(true)
let creationClient='Nouveau client'
let informations=ref()
let valid=ref()
let vendeur=ref()
let tab=ref(null)
let choixReprise1=ref(null)
let choixReprise2=ref(null)
let firstname=ref()
let lastname=ref()
let telephone=ref()
let ville=ref()
let tiers=ref()
let libelleAjout=ref('Ajouter')
let email=ref()
let birdhDay=ref()
let adresse=ref()
let codePostal=ref()
let pays=ref()
let magasin=ref(store.state.user.etablissement)
let mme=ref(false)
let mr=ref(false)
let choixReprise=ref()
let groupe=ref(['A','B','C'])

 let deleteDialog=ref()
let loading=ref(false)
let itemMagasin=ref([``,'MN01','DK03','EN11','FT04','LI02','RO06','AR09','CO18','HB21'])

let itemsPays=ref(['France','Belgique','Pays Bas','Luxembourg','Espagne','Suisse'])
const validerClient=()=>{
    store.state.clients=store.state.clients
}
let files=ref([])

const selectFile=(event)=>{

    for (let i=0;i<event.length; i++){
        files.value.push(event[i])
        addImages(event[i])
    }    


}

let rulesPhotos=ref([
    // value => {
    //   return !value || !value.length || value[0].size < '20mb' || 'Avatar size should be less than 2 MB!'
    // },
  ])
let rules1=()=>{

    if(email.value.toString().match(/^[a-z.-]+@[a-z.-]+\.[a-z]+$/i)){
        // valid.value=true
        return [true]
    } else{
        // valid.value=false
        return [`L'email n'est pas en bon format`]
    }
}
// let valid=ref(false)
let headers=ref([
    { key: 'marque',title: 'MARQUE'},
    { key: 'grade', title: 'GRADE' },
    { key: 'composition', title: 'COMPOSITION' },
    { key: 'sousFamille', title: 'SOUS_FAMILLE' },
    { key: 'libCouleur', title: 'COULEUR' },
    { key: 'prixAchatHT', title: 'PRIX_REPRISE' },
    { key: 'prixAchatOrigine', title: 'PRIX_ORIGINE' },
    { key: 'qteCommande', title: 'QTE' },
    { key: 'accessoires', title: 'ACCESSOIRES' },
    { key: 'totalBrut', title: 'TOTAL_BRUT' } 
    ]) 
    // const filen = document.getElementById("fileItem").files[0];
const NouvelleReception=(oui)=>{
    if(!oui){
        affichageClient.value=true
        creationClient='Nouveau client'
        informations.value=''
        valid.value=''
        vendeur.value=''
        tab.value=null
        firstname.value=''
        lastname.value=''
        telephone.value=''
        ville.value=''
        tiers.value=''
        libelleAjout.value='Ajouter'
        email.value=''
        birdhDay.value=''
        adresse.value=''
        codePostal.value=''
        pays.value=''
        mme.value=false
        mr.value=false
        store.commit('addClient',[]) 
    }
    terminer.value=false
    ticket.value=false
    sTicket.value=false
    tab.value="one"
    photo.value=false
    signature.value=false
    // affichageClient.value=true
    // creationClient='Nouveau client'
    // informations.value=''
    // valid.value=''
    // vendeur.value=''
    // tab.value=null
    // firstname.value=''
    // lastname.value=''
    // telephone.value=''
    // ville.value=''
    // tiers.value=''
    // libelleAjout.value='Ajouter'
    // email.value=''
    // birdhDay.value=''
    // adresse.value=''
    // codePostal.value=''
    // pays.value=''
    choixReprise2.value=false
    choixReprise1.value=false
    // mme.value=false
    // mr.value=false
    // store.commit('addClient',[]) 
    store.commit('updatephoto',true)
    store.commit('deleteArticles')
    store.commit('addSignature',{exist:false,link:''})
    store.commit('deletePhotos',{exist:false,link:[],id:[]})
}
let file=ref()
const handleFileUpload=( event )=>{
  file.value = event.target.files[0];
}


const choixClient=(item)=>{
    libelleAjout.value='Modifier'
    tab.value="two"
    store.state.clients=item
    firstname.value=item.t_prenom
    lastname.value=item.t_libelle
    telephone.value=item.t_telephone
    ville.value=item.t_ville
    tiers.value=item.t_tiers
    email.value=item.t_email
    adresse.value=item.t_adresse1
    codePostal.value=item.t_codepostal
    pays.value=item.t_pays
    // magasin.value=item.T_ETABLISSEMENT
}
const modifier=(value,id,champs)=>{
    store.commit('editRowArticle',{'value':value,'id':id,'champs':champs})
}
let itemtoDelete=ref()
const supprimer=(item)=>{
    itemtoDelete=item
}

let sum=(object,value)=>{
  let sum=0
//   //console.log(object,value);
  
  for(let key in object){
    sum=sum+(object[key][value]?Number(object[key][value]):0)
  } 
  return sum
 }
 
async  function validerArticles(){
    
    await getNumBon()
    // console.log('getnum bon');
    sendImages()
    //console.log('images send');
    let data = { 
        title:magasin.value+'-'+store.state.numeroBon,
        reception:{
            etablissement:magasin.value,
            vendeur:vendeur.value,
            numeroBon:store.state.numeroBon,
            etat:'encours',informations:informations.value,
            vendeur:vendeur.value,choixReprise:choixReprise.value,
            type:'SL',
            ticket:ticket.value,
            prenom:firstname.value},
        articles:store.state.articlesFripe,
        client:{
            "tiers":tiers.value,
            "firstname":firstname.value,
            "lastname":lastname.value,
            "email":email.value,
            "telephone":telephone.value,
            "telex":telephone.value,
            "adesse":adresse.value,
            "codePostal":codePostal.value,
            "ville":ville.value,
            "pays":pays.value,
            "sexe":mme||mr?mme?'MMme':'MR':'',
            "choixReprise":choixReprise.value,
            "magasin": magasin.value
        },
        photos:{
            // signature:store.state.signature.link,
            photos:store.state.photoLinks.id
            // signature:'',
            // photos:''
        },
        termine:false,
        token:store.state.user.token
        
    }
        
    let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: 'https://my.edisac.com/api/recordsfripe',
    headers: { 
        'Content-Type': 'application/json'
    },
    data : data
    }
    // console.log('data send');
    loading.value=false
    return axios.request(config)
    .then((response) => { 
        // console.log(response);
        
    })
    .catch((error) => {
    //console.log(error);
    });



 }

    async function getClients(){   
        let chlibelle=lastname.value?'&libelle='+lastname.value:''
        let chprenom=firstname.value?'&prenom='+firstname.value:''
        let chetablissement='&etablissement='
        let chemail=email.value?'&email='+email.value:''
        let chtelephone=telephone.value?'&telephone='+telephone.value:''
        let chcodepostal=codePostal.value?'&codepostal='+codePostal.value:''
        let chville=ville.value?'&ville='+ville.value:''
        let chpays='&pays='
        let url=    `https://my.edisac.com/api/clients`+`?${tiers.value?'tiers='+tiers.value:''}`+`${chlibelle.replace('libelle=,','libelle=').trim()}`+`${chprenom.replace('prenom=,','prenom=').trim()}`+`${chetablissement.replace('etablissement=,','etablissement=').trim()}`+`${chemail.replace('email=,','email=').trim()}`+`${chtelephone.replace('telephone=,','telephone=').trim()}`+`${chcodepostal.replace('codepostal=,','codepostal=').trim()}`+`${chville.replace('ville=,','ville=').trim()}` +`${chpays.replace('pays=,','pays=').trim()}`
        // console.log(url);
        
        let config = {
        method: 'get',
        url: url
        };
        return   axios.request(config)
        .then((response) => {
            // console.log(response.data);
            
            store.commit('addClient',response.data) 
            loading.value=false   
        })
        .catch((error) => {
        //console.log(error);
        });

    }
    const sendImages=()=>{
        // console.log({image:photo});
        
        let data = {
            reception:magasin.value+'-'+store.state.numeroBon,
            signature:store.state.signature.link,
            photos:store.state.photoLinks}
        // console.log(data);
        let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: 'https://my.edisac.com/api/upload',
        headers: { 
            'Content-Type': 'application/json'
        },
        data : data
        }
        return axios.request(config)
        .then((response) => { 
            // console.log(response);
            
        })
        .catch((error) => {
        //console.log(error);
        });
    }
    async function addImages(event){
        //console.log(event);
        const formData = new FormData();
        formData.append('file', event);
        let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: 'https://my.edisac.com/api/uploadphotos',
        headers: { 
            'Content-Type': 'multipart/form-data'
        },
        data:formData 
        }
        return axios.request(config)
        .then((response) => { 
            //console.log(response);

            store.commit('addPhotos',{exist:true,link:response.data.file,id:response.data.file})
            
        })
        .catch((error) => {
        //console.log(error);
        });
    }

    async function getReceptions(){  
    let url=    `https://my.edisac.com/api/receptions`
    // console.log(magasin.value)
    let config = {
    method: 'get',
    url: url,
    params:{finished:'false',inprogress:'true',magasin:magasin.value}
    };
    return   axios.request(config)
    .then((response) => {
        receptions.value=response.data.data.sort((a,b)=>{return b.num_reception-a.num_reception}).map(item => {
            return {
                ...item,
                title: item.etablissement + "-" + item.num_reception + "-" + item.statut
            };
        })
        dialogReceptions.value=true
    })
    .catch((error) => {
    //console.log(error);
    });
}


async function addClient(){
    let data = JSON.stringify({
        firstname:firstname.value,
        lastname:lastname.value,
        email:email.value,
        telephone:telephone.value,
        telex:telephone.value,
        adesse:adresse.value,
        codePostal:codePostal.value,
        ville:ville.value,
        pays:pays.value,
        sexe:mme||mr?mme?'MMme':'MR':'',
        magasin:magasin.value,
        choixReprise:choixReprise1?'reprendre':'association'
    });



    let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: 'https://my.edisac.com/api/client',
    headers: { 
        'Content-Type': 'application/json'
    },
    data : data
    }
    // loading.value=false
    return axios.request(config)
    .then((response) => { 
        tiers.value=response.data.tiers

    })
    .catch((error) => {
    //console.log(error);
    });
}

async function getNumBon(){  
    let url=    `https://my.edisac.com/api/numbon`
    let config = {
    method: 'get',
    url: url
    };
    return   axios.request(config)
    .then((response) => {
        store.commit('addNumBon',response.data)
        // sendNumBon()
    })
    .catch((error) => {
    //console.log(error);
    });
}
const supprimerPhoto=(el)=>{
    store.commit('deletePhoto',el)
}
async function getPhotos(el){

    let config = {
    method: 'get',
    maxBodyLength: Infinity,
    url: 'https://my.edisac.com/api/getphoto',
    headers: { 
        'Content-Type': 'application/json'
    },
    params : {photo:el}
    }

    return axios.request(config)
    .then((response) => { 
        srcImage.value=response.data
        
    })
    .catch((error) => {
    //console.log(error);
    });
}

onMounted   (()=>{

})

</script>
<style>
.fit-picture {
  text-align: center;
  width: 350px;
  height: 200px
}
.photo {
    color:blue;
    cursor: pointer;
}
.photo:hover{
    background-color: lightgrey
}
</style>